import { Search } from "@/types/types";

export function countActiveFilters(search: Search): number {
  let count = 0;

  // numeric range filters
  const rangeFields: (keyof Search)[] = [
    "price",
    "interior_space",
    "lot_size",
    "year_built",
  ];
  for (const key of rangeFields) {
    const range = search[key] as { min: number; max: number };
    if (range.min > 0 || range.max > 0) count++;
  }

  // room counts
  if (search.rooms.number > 0) count++;
  if (search.bedrooms.number > 0) count++;
  if (search.bathrooms.number > 0) count++;

  // special case
  if (search.maxBuyersFee > -1) count++;

  // boolean filters
  const booleanKeys: (keyof Search)[] = [
    "has_parking",
    "has_pool",
    "has_fitness_center",
    "has_elevator",
    "has_concierge",
    "has_security",
    "has_public_roof_deck",
    "has_roof_deck",
    "has_garage",
    "has_waterfront",
    "has_balcony",
    "has_furniture",
    "has_garden",
    "has_wine_cellar",
    "has_ac",
    "has_sauna",
    "has_gated_community",
    "is_pet_friendly",
    "has_utilities_included",
    "has_disabled_access",
    "is_ready_to_move_in",
    "has_gas",
    "has_electricity",
    "has_water",
    "has_sewage",
    "has_cafeteria",
    "has_conference_room",
    "has_public_transport",
    "has_hoa",
    "sea_view",
    "mountain_view",
    "countryside_view",
    "city_view",
    "north",
    "south",
    "east",
    "west",
  ];

  for (const key of booleanKeys) {
    if (search[key] === true) count++;
  }

  return count;
}
